//import React, { useRef, useCallback, useEffect, useState } from 'react';
import Products from "../../hooks/Productcall";
import './AllNewCollections.css';
import ProductGrid from '../ProductGrid';
import { useParams } from 'react-router-dom';

const NewCollections = () => {
  const { level } = useParams(); // Get the level from the URL parameters
  //console.log("Level from URL:", level);
  const { productData, isLoading, error, fetchProducts, hasMore } = Products(level);
  console.log("checking productData: ", productData);

  const tempTitle = (level ? level.split('-').join(' ') : 'ALL PRODUCTS').toUpperCase()

  
  return (
    <ProductGrid
      title={tempTitle}
      products={productData}
      isLoading={isLoading}
      error={error}
      hasMore={hasMore}
      fetchMore={fetchProducts}
      columns={{ xs: 2, md: 3, lg: 4 }}
    />
  );
};

export default NewCollections;